import { EQuoteStatus } from "../../api/Quote/EQuoteStatus";
import { QuoteLineItem } from "../../api/Quote/QuoteLineItem";
import { Quote } from "../../api/Quote/Quote";
import { Box } from "@material-ui/core";
import QuoteAddons from "./components/QuoteAddons";
import { FeatureAddons } from "../../app/consts";
import { hasAddons, hasSubscriptions } from "../../app/utils";
import { ProductSubscription } from "../../api/Product/ProductSubscriptionApi";
import { TF } from "../../components/typography/TF";
import { useConfig } from "../../components/config/ConfigContext";

export const QuoteRecommends = ({
  quote,
  subscriptions,
  onAddAddon,
  onChangeQuantity,
  onInfoDialogOpen,
  onAddSubscription
}: Props) => {
  const { isFeatureEnabled } = useConfig();

  if (!isFeatureEnabled(FeatureAddons)) {
    return null;
  }

  if (!quote || quote.status !== EQuoteStatus.Sent || (!hasAddons(quote.addons) && !hasSubscriptions(subscriptions))) {
    return null;
  }

  return (
    <>
      <Box>
        <Box textAlign="center">
          <TF variant="h5" paragraph bold>
            Recommended Products
          </TF>
          <TF variant="body1">
            Your engineer has recommended these products to save energy and money on your heating bills.
          </TF>
        </Box>

        <QuoteAddons
          quote={quote}
          addons={quote.addons}
          subscriptions={subscriptions}
          onAddSubscription={onAddSubscription}
          onAddAddon={onAddAddon}
          onInfoDialogOpen={onInfoDialogOpen}
          onChangeQuantity={onChangeQuantity}
        />
      </Box>
    </>
  );
};

interface Props {
  quote: Quote;
  subscriptions: ProductSubscription[] | null;
  onAddAddon: (addon: QuoteLineItem) => void;
  onInfoDialogOpen: (addon: QuoteLineItem) => void;
  onAddSubscription: (subscription: ProductSubscription) => void;
  onChangeQuantity: (addon: QuoteLineItem, quantity: number) => void;
}
